import { render, staticRenderFns } from "./小睡眠服务协议-安卓.vue?vue&type=template&id=f7a92b08&scoped=true"
import script from "./小睡眠服务协议-安卓.vue?vue&type=script&lang=js"
export * from "./小睡眠服务协议-安卓.vue?vue&type=script&lang=js"
import style0 from "./小睡眠服务协议-安卓.vue?vue&type=style&index=0&id=f7a92b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a92b08",
  null
  
)

export default component.exports